import React from 'react';
import PropTypes from 'prop-types';
import {Container} from '../';
import {Link} from 'react-router';

class Route404 extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Route404';
    }
    render() {
        return (
        	<Container title="404">

						<section className="body-error error-inside">
							<div className="center-error">

								<div className="row">
									<div className="col-md-8">
										<div className="main-error mb-xlg">
											<h2 className="error-code text-dark text-center text-weight-semibold m-none">404 <i className="fa fa-file"></i></h2>
											<p className="error-explanation text-center">We're sorry, but the page you were looking for doesn't exist.</p>
										</div>
									</div>
									<div className="col-md-4">
										<h4 className="text">Here are some useful links</h4>
										<ul className="nav nav-list primary">
											<li>
												<Link to='/'><i className="fa fa-caret-right text-dark"></i> Dashboard</Link>
											</li>
											<li>
												<Link to='/map/search'><i className="fa fa-caret-right text-dark"></i> Map Search</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</section>

        	</Container>
        );
    }
}

export default Route404;


// WEBPACK FOOTER //
// ./src/browser/components/app/404.js